<template>
    <!-- Content Wrapper. Contains page content -->
    <div class="content-wrapper">
        <!-- Content Header (Page header) -->
        <div class="content-header">
            <div class="container-fluid">
                <div class="row mb-2">
                    <div class="col-sm-6">
                        <h1 class="m-0">IP WhiteListesi</h1>
                    </div>
                    <!-- /.col -->
                    <div class="col-sm-6">
                        <ol class="breadcrumb float-sm-right">
                            <router-link tag="li" to="/" class="breadcrumb-item">
                                <a>Anasayfa</a>
                            </router-link>
                            <li class="breadcrumb-item active">IP WhiteListesi</li>
                        </ol>
                    </div>
                    <!-- /.col -->
                </div>
                <!-- /.row -->
            </div>
            <!-- /.container-fluid -->
        </div>
        <!-- /.content-header -->

        <!-- Main content -->
        <div class="content">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="card">
                            <div class="card-header card-title">
                                Ip WhiteListesi
                                <button class="btn btn-primary btn-sm float-right" @click="resetModal">
                                    <i class="fas fa-plus"></i> Yeni IP
                                </button>
                            </div>
                            <div class="card-body">
                                <div class="overlay-wrapper">
                                    <div class="overlay" v-if="overlay">
                                        <i class="fas fa-3x fa-spinner fa-spin"></i>
                                    </div>
                                    <div class="row  justify-content-start">
                                        <div class="col-xl-6">
                                            <input type="text" placeholder="Ip Address" class="form-control"
                                                v-model="search.ip_adress" />
                                        </div>

                                        <div class="col-xl-2">
                                            <button class="btn btn-info btn-sm w-100" @click="pagination">
                                                <i class="fas fa-search"></i> Filtrele
                                            </button>

                                        </div>
                                        <div class="col-xl-2">
                                            <button class="btn btn-danger btn-sm w-100" @click="reset">
                                                Temizle
                                            </button>
                                        </div>
                                    </div>
                                    <br>
                                    <div class="table-responsive" style="min-height:500px;">
                                        <table class="table table-striped projects">
                                            <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>IP Address</th>
                                                    <th>Description</th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(data, index) in dataList" :key="index">
                                                    <td>{{ ++index + (page - 1) * count }}</td>
                                                    <td>{{ data.ip_adress }}</td>
                                                    <td>{{ data.description }}</td>

                                                    <td>
                                                        <button class="btn btn-outline-info btn-sm" @click="getModal(data)">
                                                            <i class="fas fa-pencil-alt"></i>
                                                        </button>
                                                        <button class="btn btn-outline-danger btn-sm" @click="del(data.id)">
                                                            <i class="fa fa-trash"></i>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td v-if="dataList.length == 0" colspan="4" class="text-center">Kayıt
                                                        Bulunamadı
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>

                                    </div>
                                </div>
                            </div>
                            <div class="card-footer">
                                <div class="card-footer">
                                    <pagination v-model="page" :records="rows" :per-page="count" @paginate="pagination" />
                                </div>
                            </div>
                        </div>

                        <!-- /.card -->
                    </div>
                </div>
                <!-- /.row -->
            </div>
            <!-- /.container-fluid -->
        </div>
        <div class="modal fade" id="modal">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Ip White List {{ data.id ? "Düzenleme" : "Ekleme" }}</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form @submit.prevent="onSubmit">
                            <div class="form-group">
                                <label>Ip Address</label>
                                <input type="text" placeholder="Ip Address" v-model="data.ip_adress" class="form-control" />
                            </div>
                            <div class="form-group">
                                <label>Description</label>
                                <textarea v-model="data.description" class="form-control"
                                    placeholder="Description"></textarea>
                            </div>
                        </form>
                    </div>

                    <div class="modal-footer justify-content-between">
                        <button type="button" class="btn btn-default" data-dismiss="modal">İptal</button>
                        <button type="button" class="btn btn-primary" @click="save()"
                            :disabled="$v.data.$invalid">Kaydet</button>
                    </div>
                </div>
                <!-- /.modal-content -->
            </div>
            <!-- /.modal-dialog -->
        </div>
        <!-- /.content -->
    </div>
    <!-- /.content-wrapper -->
</template>
<script>
import {
    required,
} from "vuelidate/lib/validators";

export default {
    data() {
        return {
            page: 1,
            count: 10,
            rows: 0,
            dataList: [],
            auth: this.$store.getters.getModules,
            data: {
                id: 0,
                ip_adress: "",
                description: "",
                created_user_id: 0,
            },
            overlay: false,
            search: {
                ipAddress: "",
            }
        };
    },
    validations: {
        data: {
            ip_adress: { required },
            description: { required }
        },
    },
    filters: {
        DateFormat(value) {
            if (!value) return "Giriş Yapılmamış";

            let date = value.split("T")[0].split("-");
            let time = value.split("T")[1].split(".")[0];
            return date[2] + "/" + date[1] + "/" + date[0] + " " + time;
        },

    },
    methods: {
        pagination(value) {
            this.getData();
        },
        reset() {
            this.page = 1;
            this.search = {
                ip_adress: "",
            };
            this.getData();
        },
        getData() {
            this.overlay = true;
            this.$http
                .post("IpWhitelist/GetList", {
                    page: this.page - 1,
                    ip_adress: this.search.ip_adress
                })
                .then((response) => {
                    this.overlay = false;
                    this.rows = response.data.TotalCount;
                    this.dataList = response.data.Data;
                });

        },
        save() {
            this.overlay = true;
            var AdminId = localStorage.getItem("id");
            this.data.created_user_id = AdminId;
            this.$http
                .post("IpWhitelist/Save", this.data)
                .then((response) => {
                    console.log(response);
                    toastr.success("Kayıt başarılı.");
                    $("#modal").modal("hide");
                    this.getData();


                });
        },
        resetModal() {
            this.data = {
                id: 0,
                ip_adress: "",
                description: "",
            };
            this.$v.$reset();
            $("#modal").modal();
        },
        del(id) {
            Swal.fire({
                title: "Kayıt kalıcı olarak silinecek! Onaylıyor musunuz?",
                showCancelButton: true,
                confirmButtonText: "Evet! Silinsin",
                cancelButtonText: "İptal",
                icon: "question",
            }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                    var AdminId = localStorage.getItem("id"); 
                    this.$http.post("IpWhitelist/Delete/?id=" + id + "&AdminId=" + AdminId).then((response) => {
                        toastr.success("Kayıt başarıyla silindi.");
                        this.getData();
                    });
                }
            });
        },
        getModal(data) {
            this.$v.$reset();
            this.data.id = data.id;
            this.data.ip_adress = data.ip_adress;
            this.data.description = data.description;
            $("#modal").modal();
        }
    },
    watch: {
        "$store.getters.getModules"() {
            this.auth = this.$store.getters.getModules;
        },
    },
    created() {
        // get data
        this.getData();
    },
};
</script>


// WEBPACK FOOTER //
// src/components/User/ipWhiteList.vue